import React from "react";
import { FiCompass } from "react-icons/fi";
import EmptyState from "../components/common/EmptyState";
import PageMeta from "../components/common/PageMeta";

const NotFoundPage = () => <div className="not-found-page"><PageMeta title="Page Not Found" /><EmptyState icon={FiCompass} title="This path isn’t on the map" description="The page may have moved, but the pantry is still open." actionLabel="Return to the pantry" actionTo="/shop" /></div>;

export default NotFoundPage;
